"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _conferenceService, _sessionService, _videoFiltersHelper, _cacheFilter, _cacheFilterOptions, _cacheVideoTrack;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFilterInConferenceController = void 0;
const logging_1 = __importDefault(require("../../lib/logging"));
const Service_1 = require("../Service");
const events_1 = require("../../events");
const MediaStream_1 = require("../../models/MediaStream");
const Exceptions_1 = require("../../lib/Exceptions");
const VideoFilters_1 = require("../../models/VideoFilters");
/**
 * @ignore
 * Internal class.
 * Class listens conference events and applies video filters on camera stream.
 */
let VideoFilterInConferenceController = class VideoFilterInConferenceController {
    constructor(conferenceService, sessionService, videoFiltersHelper) {
        _conferenceService.set(this, void 0);
        _sessionService.set(this, void 0);
        _videoFiltersHelper.set(this, void 0);
        _cacheFilter.set(this, VideoFilters_1.VideoFilter.None);
        _cacheFilterOptions.set(this, {});
        _cacheVideoTrack.set(this, null);
        __classPrivateFieldSet(this, _conferenceService, conferenceService);
        __classPrivateFieldSet(this, _sessionService, sessionService);
        __classPrivateFieldSet(this, _videoFiltersHelper, videoFiltersHelper);
    }
    setFilter(filter, filterOptions = {}) {
        return new Promise((resolve, reject) => {
            if (!__classPrivateFieldGet(this, _videoFiltersHelper).isFilterSupported(filter)) {
                reject(new Exceptions_1.UnsupportedError("Setting video filter on camera stream failed. Filter '" + filter + "' is unsupported"));
                return;
            }
            __classPrivateFieldSet(this, _cacheFilter, filter);
            __classPrivateFieldSet(this, _cacheFilterOptions, Object.assign({}, filterOptions));
            if (this.isLiveVideoTrack(__classPrivateFieldGet(this, _cacheVideoTrack)))
                resolve(__classPrivateFieldGet(this, _videoFiltersHelper).setFilter(__classPrivateFieldGet(this, _cacheVideoTrack), __classPrivateFieldGet(this, _cacheFilter), __classPrivateFieldGet(this, _cacheFilterOptions)));
            else
                resolve();
        });
    }
    isLocalParticipant(peerId) {
        return peerId === __classPrivateFieldGet(this, _sessionService).participant.id;
    }
    isLiveVideoTrack(videoTrack) {
        return videoTrack && videoTrack.readyState === 'live';
    }
    hasLiveVideoTrack(stream) {
        return stream.getVideoTracks().length > 0 && this.isLiveVideoTrack(this.getVideoTrackFrom(stream));
    }
    getVideoTrackFrom(stream) {
        return stream.getVideoTracks()[0];
    }
    isCameraStreamType(stream) {
        return stream && stream.type === MediaStream_1.MediaStreamType.Camera;
    }
    onStreamAdded(event) {
        if (!__classPrivateFieldGet(this, _videoFiltersHelper).isFilterSupported(__classPrivateFieldGet(this, _cacheFilter)))
            return;
        if (this.isLocalParticipant(event.peerId) && this.hasLiveVideoTrack(event.stream) && this.isCameraStreamType(event.stream)) {
            __classPrivateFieldSet(this, _cacheVideoTrack, this.getVideoTrackFrom(event.stream));
            __classPrivateFieldGet(this, _videoFiltersHelper).setFilter(__classPrivateFieldGet(this, _cacheVideoTrack), __classPrivateFieldGet(this, _cacheFilter), __classPrivateFieldGet(this, _cacheFilterOptions))
                .catch((e) => logging_1.default.warn('Setting video filter on camera stream failed. ' + e));
        }
    }
    onStreamUpdated(event) {
        if (!__classPrivateFieldGet(this, _videoFiltersHelper).isFilterSupported(__classPrivateFieldGet(this, _cacheFilter)))
            return;
        if (this.isLocalParticipant(event.peerId) && this.isCameraStreamType(event.stream)) {
            if (this.hasLiveVideoTrack(event.stream)) {
                __classPrivateFieldSet(this, _cacheVideoTrack, this.getVideoTrackFrom(event.stream));
                __classPrivateFieldGet(this, _videoFiltersHelper).setFilter(__classPrivateFieldGet(this, _cacheVideoTrack), __classPrivateFieldGet(this, _cacheFilter), __classPrivateFieldGet(this, _cacheFilterOptions))
                    .catch((e) => logging_1.default.warn('Setting video filter on camera stream failed. ' + e));
            }
            else {
                __classPrivateFieldSet(this, _cacheVideoTrack, null);
            }
        }
    }
    onStreamRemoved(event) {
        if (!__classPrivateFieldGet(this, _videoFiltersHelper).isFilterSupported(__classPrivateFieldGet(this, _cacheFilter)))
            return;
        if (this.isLocalParticipant(event.peerId) && this.isCameraStreamType(event.stream)) {
            __classPrivateFieldSet(this, _cacheVideoTrack, null);
        }
    }
    onConferenceVideoFilterUpdate(event) {
        if (!__classPrivateFieldGet(this, _videoFiltersHelper).isFilterSupported(event.filter)) {
            logging_1.default.warn("Setting video filter on camera stream failed. Filter '" + event.filter + "' is unsupported");
            return;
        }
        this.setFilter(event.filter, event.filterOptions);
    }
};
_conferenceService = new WeakMap(), _sessionService = new WeakMap(), _videoFiltersHelper = new WeakMap(), _cacheFilter = new WeakMap(), _cacheFilterOptions = new WeakMap(), _cacheVideoTrack = new WeakMap();
VideoFilterInConferenceController = __decorate([
    Service_1.Subscribe([events_1.EventType.ConferenceVideoFilterUpdate, events_1.EventType.StreamAdded, events_1.EventType.StreamRemoved, events_1.EventType.StreamUpdated])
], VideoFilterInConferenceController);
exports.VideoFilterInConferenceController = VideoFilterInConferenceController;
